import { assign, isArray } from 'lodash';
import deviceApi from 'api/home/device-mangement';
const { getGbIndustryList: a, getGbDeviceTypeList: b, getGbNetWorkList: c, getGbCityList: d } = deviceApi
const gbTypeList = {
    industry: 'industryList',
    gbType: 'gbDeviceTypeList',
    network: 'networkAccessList',
}
export function getGbList(vueData) {
    Promise.all([
        a()
            .then((res) => {
                return { industry: res }
            })
            .catch((err) => {
                return { industry: err }
            }),
        b()
            .then((res) => {
                return { gbType: res }
            })
            .catch((err) => {
                return { gbType: err }
            }),
        c()
            .then((res) => {
                return { network: res }
            })
            .catch((err) => {
                return { network: err }
            }),
    ]).then(res => {
        let obj = {};
        for (const iterator of res) {
            Object.assign(obj, iterator);
        }
        for (const key in obj) {
            const {
                data: { data, code }
            } = obj[key];
            if (code !== 200) {
                return;
            }
            vueData[gbTypeList[key]] = data;
        }
    })
};
